import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as RemoveIcon } from 'images/cancel-24.svg';
import styles from 'modules/Profile/components/FamilyAccess/FamilyAccess.module.scss';
import Modal from 'components/Modal';
import Tooltip from 'components/Tooltip';
import Button, { BUTTON_COLORS } from 'components/Button';

const WardActions = ({
  columnProps: {
    rest: { inn, active, terminationReason, onRemove, relationAvailable },
  },
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const onRemoveItem = useCallback(() => {
    setModalVisible(false);
    onRemove({ inn });
  }, [inn, onRemove]);

  if (active && relationAvailable) {
    return (
      <>
        <RemoveIcon className={styles.removeIcon} onClick={() => setModalVisible(true)} />
        <Modal showModal={modalVisible} onClose={() => setModalVisible(false)}>
          <h2>Прекращение доступа</h2>
          <p>
            Даю согласие на прекращение доступа к информации из Личного кабинета налогоплательщика
            несовершеннолетнего ребенка.
          </p>
          <div className={styles.actions}>
            <Button
              extraClassName={styles.button}
              color={BUTTON_COLORS.WHITE_BLUE}
              hasWrapper={false}
              onClick={() => setModalVisible(false)}
            >
              Отменить
            </Button>
            <Button
              extraClassName={styles.button}
              color={BUTTON_COLORS.ORANGE}
              hasWrapper={false}
              onClick={onRemoveItem}
            >
              Удалить
            </Button>
          </div>
        </Modal>
      </>
    );
  }
  return terminationReason ? (
    <Tooltip
      content={terminationReason}
      fixed={true}
      isFormClass={false}
      hasWrapper={false}
      position={'left'}
    />
  ) : null;
};

WardActions.propTypes = {
  columnProps: PropTypes.object,
};

export default WardActions;
